// Asset Management ERP Application
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/layout/app-layout';
import { CopilotProvider } from '@/providers/copilot-provider';
import { SystemOptionsProvider } from '@/contexts/SystemOptionsContext';
import Dashboard from '@/pages/dashboard';
import AssetsPage from '@/pages/assets';
import AdditionsPage from '@/pages/transactions/additions';
import DepreciationPage from '@/pages/transactions/depreciation';
import RevaluationPage from '@/pages/transactions/revaluation';
import InsightsPage from '@/pages/insights';
import Enquiry from '@/pages/enquiry';
import HelpPage from '@/pages/help';
import Administration from '@/pages/administration';
import LocationsPage from '@/pages/settings/locations';
import CategoriesPage from '@/pages/settings/categories';
import EquipmentPage from '@/pages/settings/equipment';
import DisposalReasonsPage from '@/pages/settings/disposal-reasons';
import ImportsPage from '@/pages/settings/imports';
import ImportTransactionsPage from '@/pages/settings/import-transactions';
import AssetOptionsPage from '@/pages/settings/asset-options';
import FeaturesSettingsPage from '@/pages/settings/features';
import CompliancePage from '@/pages/compliance';
import ComplianceSettingsPage from '@/pages/compliance-settings';
import AuditPage from '@/pages/audit';
import CheckInOutDashboard from '@/pages/checkinout/dashboard';
import CheckInOutCalendar from '@/pages/checkinout/calendar';
import CheckInOutSettingsPage from '@/pages/checkinout/settings';
import CheckOutAsset from '@/pages/checkinout/checkout';

export default function App(): React.ReactElement {
  return (
    <CopilotProvider>
      <SystemOptionsProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="assets" element={<AssetsPage />} />
            <Route path="transactions">
              <Route path="additions" element={<AdditionsPage />} />
              <Route path="depreciation" element={<DepreciationPage />} />
              <Route path="revaluation" element={<RevaluationPage />} />
            </Route>
            <Route path="insights" element={<InsightsPage />} />
            <Route path="enquiry" element={<Enquiry />} />
            <Route path="audit" element={<AuditPage />} />
            <Route path="compliance" element={<CompliancePage />} />
            <Route path="compliance/settings" element={<ComplianceSettingsPage />} />
            <Route path="checkinout">
              <Route index element={<CheckInOutDashboard />} />
              <Route path="calendar" element={<CheckInOutCalendar />} />
              <Route path="checkout" element={<CheckOutAsset />} />
              <Route path="settings" element={<CheckInOutSettingsPage />} />
            </Route>
            <Route path="administration">
              <Route index element={<Administration />} />
              <Route path="imports" element={<ImportsPage />} />
              <Route path="import-transactions" element={<ImportTransactionsPage />} />
              <Route path="locations" element={<LocationsPage />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="equipment" element={<EquipmentPage />} />
              <Route path="disposal-reasons" element={<DisposalReasonsPage />} />
            </Route>
            <Route path="settings">
              <Route path="features" element={<FeaturesSettingsPage />} />
              <Route path="asset-options" element={<AssetOptionsPage />} />
            </Route>
            <Route path="help" element={<HelpPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </SystemOptionsProvider>
    </CopilotProvider>
  );
}
